class SaveToTherefore {
  constructor(apiClass) {
    this.apiClass = apiClass;
  }

  callApi = async (doc) => {
    const apiRoute =
      process.env.REACT_APP_AZURE_API_SECURED_MESSAGE_CENTER +
      "messages/" +
      "ArchiveToTherefore";
    return await this.apiClass.CallApiSkipErrorHandling("post", apiRoute, doc);
  };
}

export default SaveToTherefore;
